headerHiddenByExperiment